import { IErrors } from '../model/errors.model';

export const UNKNOWN_ERROR: IErrors = { UnknownError: ['UnknownError'] };

export const BAD_REQUEST_ERROR: IErrors = { 400: ['BadRequest'] };

export const INTERNAL_SERVER_ERROR: IErrors = { 500: ['InternalServerError'] };
